import * as React from 'react';
import { useGetUserAddressQuery } from "../../../apis/UserAddress.api";
import { PrimaryUserAddress, UserAddress } from "../../../types/models/UserAddress";
import UserName from "../../../../auth/components/user/UserDetail/UserName";
import AddressName from "../../../../address/components/address/AddressDetail/AddressName";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: UserAddress;
};

export const UserAddressNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<><UserName id={ data?.userId }/>
                    {data?.addressId && <> | </> }<AddressName id={ data?.addressId }/>
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const UserAddressName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetUserAddressQuery(PrimaryUserAddress.fromId(id))
    return (<UserAddressNameDisplay data={data}/>)
}

export default UserAddressName;
